import CreativeArts from "./RCIICreativeArts";
import EmotionalSkills from "./RCIIEmotionalSkills";
import FineMotor from "./RCIIFineMotor";
import GrossMotor from "./RCIIGrossMotor";
import LearningExperience from "./RCIILearningExperience";
import Mathematics from "./RCIIMathematics";
import SelfConcept from "./RCIISelfConcept";
import SocialSkills from "./RCIISocialSkills";
import ScienceSensory from "./StatementScienceSensory";
import LanguageAndLiteracy from "./RCIILanguageAndLIteracy";
import { useAppSelector } from "../../app/store/configureStore";
import ResourceIIStatus from "./ResourceIIStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import { Grid, Typography } from "@mui/material";
import LoadingSpinner from "../../app/common/LoadingSpinner";
import agent from "../../app/api/agent";
import { useCallback, useEffect, useState } from "react";
import { Answers } from "../../app/models/Answers";
import CongratsPopUp from "../../app/common/CongratsPopUp";

export default function ResourceCollectionII() {
  const { user } = useAppSelector((state) => state.account);
  const [summaryDescription] = useState<any>(
    (user?.credentialTypeId === 1 && (
      <Typography component="div">
        Here you will describe nine learning experiences for infants and
        toddlers:
        <ol>
          <li>three for young infants</li>
          <li>three for mobile infants</li>
          <li>three for toddlers</li>
        </ol>
        Complete each of the sections below by expanding the list items and
        filling out the forms.
      </Typography>
    )) ||
      (user?.credentialTypeId === 2 && (
        <Typography>
          Here you will describe nine learning experiences for preschool
          children ages 3-5. You can also find examples of developmentally
          appropriate activities in your training curriculum. Be sure to say how
          you will make accommodations for children with disabilities. Complete
          each of the sections below by expanding the list items and filling out
          the forms.
        </Typography>
      )) ||
      (user?.credentialTypeId === 3 && (
        <Typography>
          Here you will describe nine learning experiences for children.
          Complete each of the sections below by expanding the list items and
          filling out the forms.
        </Typography>
      )) ||
      (user?.credentialTypeId === 4 && (
        <Typography>
          Here you will describe eight learning experiences you teach families,
          written in your own words. You can see two examples in your CDA
          Competency Standards book. Complete each of the sections below by
          expanding the list items and filling out the forms
        </Typography>
      ))
  );

  // (user?.credentialTypeId === 1 &&
  //   `Here you will describe nine learning experiences for infants and toddlers: <ol>three for young infants, three for mobile infants, and three for toddlers. Complete each of the sections below by expanding the list items and filling out the forms.`) ||
  //   (user?.credentialTypeId === 2 &&
  //     "Here you will describe nine learning experiences for preschool children ages 3-5. You can also find examples of developmentally appropriate activities in your training curriculum. Be sure to say how you will make accommodations for children with special needs. Complete each of the sections below by expanding the list items and filling out the forms.") ||
  //   (user?.credentialTypeId === 3 &&
  //     "Here you will describe nine learning experiences for children. Complete each of the sections below by expanding the list items and filling out the forms.") ||
  //   (user?.credentialTypeId === 4 &&
  //     "Here you will describe eight learning experiences you teach families, written in your own words. You can see two examples in your CDA Competency Standards book. Complete each of the sections below by expanding the list items and filling out the forms.");

  const [summaryCompleteProps, setSummaryCompleteProps] =
    useState<SummaryCompleteProps>({
      title: "My Resource Collection II",
      percent: "",
      header:
        "Competency II: To advance children's physical and intellectual competence",
      description: summaryDescription,
    });

  const [answers, setAnswers] = useState<Answers[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [compComplete, setCompComplete] = useState(0);
  const [popUp, setPopUp] = useState(false);
  const handlePopUp = () => {
    setPopUp(false);
  };

  const fetchData = useCallback(async () => {
    try {
      if (user?.credentialName && user?.portfolioId) {
        const response = await agent.Answers.GetAnswers(
          user.credentialName,
          user.portfolioId,
          "RCII"
        );
        const compData = await agent.Progress.GetCompentencyResultsByType(
          user.portfolioId,
          "RCII"
        );

        setCompComplete(compData.resourceProgress); //for congrats popup

        setSummaryCompleteProps((prevSummaryCompleteProps) => ({
          ...prevSummaryCompleteProps,
          percent: compData.resourceProgress + "%",
        }));
        setAnswers(response);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }, [user?.credentialName, user?.portfolioId]);

  const handleComplete = () => {
    if (compComplete >= 100) {
      setPopUp(true);
    }
  };
  useEffect(() => {
    fetchData();
    handleComplete();
  }, [fetchData]);

  const handleAnswerChange = (systemCodeId: number, newValue: string) => {
    setAnswers((prevAnswers) =>
      prevAnswers.map((answer) =>
        answer.systemCodeId === systemCodeId
          ? { ...answer, answer: newValue }
          : answer
      )
    );
  };

  const handleSave = async () => {
    setIsLoading(true);
    const filteredAnswers = answers.filter(
      (answer) => answer.id !== 0 || answer.answer !== ""
    );
    await agent.Answers.InsertorUpdateAnswers(filteredAnswers);
    fetchData();
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Grid container p={2} mb={2}>
      <CongratsPopUp
        handlePopUp={handlePopUp}
        isPopUp={popUp}
        btnColor={"info"}
        background={"#E9F6FC"}
        description={
          "You have completed your Competency II Reflective Statement."
        }
      />

      <ResourceIIStatus {...summaryCompleteProps} />
      <LearningExperience />
      {user?.credentialTypeId === 4 ? null : (
        <ScienceSensory
          answersData={answers}
          onAnswerChange={handleAnswerChange}
          onSave={handleSave}
        />
      )}
      <LanguageAndLiteracy
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <CreativeArts
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <FineMotor
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <GrossMotor
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <SelfConcept
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <EmotionalSkills
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <SocialSkills
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
      <Mathematics
        answersData={answers}
        onAnswerChange={handleAnswerChange}
        onSave={handleSave}
      />
    </Grid>
  );
}
